import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function LanguageToggle() {
  const { i18n } = useTranslation()
  const isHe = i18n.language === 'he'

  useEffect(() => {
    document.documentElement.dir = isHe ? 'rtl' : 'ltr'
    document.documentElement.lang = isHe ? 'he' : 'en'
  }, [isHe])

  return (
    <button
      onClick={() => void i18n.changeLanguage(isHe ? 'en' : 'he')}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
      style={{ background: '#252836', border: '1px solid #2d3148', color: '#9ca3af' }}
      title={isHe ? 'Switch to English' : 'עבור לעברית'}
    >
      {isHe ? 'EN' : 'עב'}
    </button>
  )
}
